import { useEffect, useState } from 'react'
import axios from 'axios'
import { Pagination } from 'antd'
import AlumniRevisitAppointmentRibbon from './ribbon'
import AlumniRevisitAppointmentDetail from './detail'

export default function AlumniRevisitAppointment() {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [currentPage, setCurrentPage] = useState(1)
  const [propsData, setPropsData] = useState({})
  const [appointmentData, setAppointmentData] = useState({})
  const [isDetailVisible, setIsDetailVisible] = useState(false)

  const initialConditions = {
      status: ''
    }
    const [filterValue, setFilterValue] = useState(initialConditions)

  const getAppointmentData = () => {
    axios.post('/p/alumni/revisit_appointment/list/get', { 
      merchant_oid: merchantOid,
      status: filterValue.status,
      page: currentPage, 
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setAppointmentData({
            'total_page': response.data.total_page,
            'current_page': response.data.current_page,
            'total': response.data.total,
            'revisit_appointments': response.data.revisit_appointments
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getAppointmentData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, currentPage, filterValue])

  const getColor = (key) => {
    if (key === 2) return 'green'
    if (key === 3) return 'red'
    return 'black'
  }

  const previewDetail = (oid) => {
    setIsDetailVisible(true)
    setPropsData({ oid: oid})
  }

  return (
    <div className="public-page">
      <div className="public-container">
        <div className="public-header">
          <div className="public-title">返校预约</div>
          <AlumniRevisitAppointmentRibbon 
            filterValue={filterValue} 
            setFilterValue={setFilterValue}
          />
        </div>

        <div className='public-main-style2'>
          <table className='public-main-style2-item'>
            <thead>
              <tr className='public-main-style2-thead'>
                <th style={{textAlign: 'left', paddingLeft: '20px'}}>姓名</th>
                <th>手机号</th>
                <th>审核状态</th>
                <th>申请时间</th>
              </tr>
            </thead>

            <tbody>
              {appointmentData.revisit_appointments && (appointmentData.revisit_appointments.length > 0 ? (appointmentData.revisit_appointments.map((item) => (
                <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { previewDetail(item.oid) }}>
                  <td style={{textAlign: 'left', paddingLeft: '20px'}}>{item.name}</td>
                  <td>{item.phone}</td>
                  <td style={{ color: getColor(item.status.key) }}>{item.status.value}</td>
                  <td>{item.create_time}</td>
                </tr>
              ))) : (
                <tr className='public-main-style2-tbodyEmpty'>
                  <td colSpan="4"><span>暂无数据</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className='pagination'>
          <Pagination 
            current={currentPage}
            total={appointmentData.total}
            pageSize={20}
            onChange={(page) => setCurrentPage(page)}
            showTotal={(total) => `共${total}条`}
            showSizeChanger={false}
            hideOnSinglePage={true}
            showQuickJumper={true}
          />
        </div>

        {isDetailVisible && <AlumniRevisitAppointmentDetail
          data={propsData}
          isOpen={isDetailVisible}
          getAppointmentData={getAppointmentData}
          isCancel={() => { setIsDetailVisible(false) }}
        />}
      </div>
    </div>
  )
}
